var map = {
	"./Armario.png": 592,
	"./Asistencia en carretera.png": 1507,
	"./Batería.png": 593,
	"./Baño.png": 276,
	"./Calor.png": 1508,
	"./Casa color 1.png": 1509,
	"./Chapa y pintura.png": 1510,
	"./Climatizacion.png": 594,
	"./Coche Climatización.png": 1511,
	"./Coche Desguace.png": 1512,
	"./Coche Limpieza.png": 1513,
	"./Coche Luna.png": 1514,
	"./Coche accesorios.png": 595,
	"./Coche color.png": 596,
	"./Coche duda.png": 597,
	"./Coche eléctrico.png": 1515,
	"./Cocina.png": 598,
	"./Escaleras.png": 1516,
	"./ITV.png": 1517,
	"./Neumáticos.png": 1518,
	"./Panel solar.png": 599,
	"./Pared.png": 1519,
	"./Persianas.png": 600,
	"./Puerta de paso.png": 601,
	"./Revisiones.png": 1520,
	"./Suelo.png": 367,
	"./Taladro.png": 602,
	"./Tejado.png": 603,
	"./albanil.png": 604,
	"./antenista.png": 605,
	"./carp.madera.png": 1521,
	"./carp.metal.png": 606,
	"./cerrajero.png": 607,
	"./construccion.png": 608,
	"./cristalero.png": 368,
	"./customizacion.png": 369,
	"./electricista.png": 609,
	"./electrodomesticos.png": 370,
	"./fontanero.png": 610,
	"./jardinero.png": 611,
	"./limpieza.png": 612,
	"./manitas.png": 613,
	"./mudanzas.png": 1522,
	"./pintor.png": 614,
	"./piscina.png": 371,
	"./reformas.png": 372,
	"./toldos-y-persianas.png": 615
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 366;